import React from "react";
import Noti from "../../../util/noti";

import SiteCreationChild from "./SiteCreationChild";
import ConstructionTable from "./ConstructionTable";

function SiteCreationConstructionTable() {
	return (
		<SiteCreationChild requiredRoles={['administration:SiteCreation:_view']} showConsActionBtn={true}>
			<ConstructionTable />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationConstructionTable;